module.exports = "<esri-map #esriMap (viewCreated)=\"onViewCreated()\">\n  <coordinate [map-view]=\"esriMap.mapView\"></coordinate>\n</esri-map>";


//////////////////
// WEBPACK FOOTER
// ./app/app.component.html
// module id = 662
// module chunks = 1